<template>
  <div class="wrap" @click="navTo">
    <!-- <router-link
      target="_blank"
      :to="{ path: '/greenwritedetail', query: { id: obj.id } }"
      class="wrap-cover"
    >
      <el-image class="wrap-cover-img" :src="obj.image" fit="cover"></el-image>
      <div class="wrap-cover-tag">{{ obj.cate_id }}</div>
    </router-link> -->
    <div
      target="_blank"
      :to="{ path: '/greenwritedetail', query: { id: obj.id } }"
      class="wrap-cover"
    >
      <el-image class="wrap-cover-img" :src="obj.image" fit="cover"></el-image>
      <div class="wrap-cover-tag">{{ obj.cate_id }}</div>
    </div>
    <div class="wrap-title">{{ obj.title }}</div>
    <div class="wrap-author">作者：{{ obj.author }}</div>
    <div class="wrap-time">时间：{{ obj.created_at }}</div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    obj: Object,
  },
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    navTo(){
      this.$emit('tab',{})
    }
  },
  created() {},
  mounted() {},
};
</script>
<style lang="less" scoped>
/deep/ .el-image__error {
  background-color: #58b75b;
  color: #fff;
}
.wrap {
  cursor: pointer;
  &-cover {
    display: flex;
    border-radius: 10px;
    overflow: hidden;
    position: relative;
    width: 261px;
    height: 261px;
    // background-color: #58b75b;
    &-img {
      width: 100%;
      height: 100%;
    }
    &-tag {
      position: absolute;
      left: 0;
      bottom: 0;
      padding: 4px 12px;
      color: #fff;
      font-size: 12px;
      border-top-right-radius: 10px;
      background-color: rgba(0, 0, 0, 0.4);
      overflow: hidden;
    }
  }
  &-title {
    font-size: 15px;
    margin-top: 36px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }
  &-author {
    color: #999;
    margin-top: 20px;
    font-size: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }
  &-time {
    margin-top: 6px;
    color: #999;
    font-size: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/home/components/newwordsItem.vue